// import modules
import Vue from 'vue';
import VueI18n from 'vue-i18n';
import {params} from './params';
Vue.use(VueI18n);

// import translations
import translationsDefault from '../static/languages/ru.json';

// default language
export const languageDefault = params['languageDefault'];

/**
 * Get current language code.
 * @returns {String} current language code.
 */
export const languageCurrent = function() {
	// get cookie value
	let language = ('undefined' === typeof Cookies.get('language')) ? languageDefault : Cookies.get('language');

	// detect if this language is not default
	if (language !== languageDefault) {
		// get language codes
		const languages = [];
		params.languages.forEach(function (item) {
			languages.push(item[0]);
		});

		// validate current language code
		if (!languages.includes(language)) {
			language = languageDefault;
		}
	}

	// result
	return language;
};

// messages object
const messages = {};
messages[languageDefault] = translationsDefault;

// i18n config object
const i18n = new VueI18n({
	locale: languageDefault,
	fallbackLocale: languageDefault,
	messages
});

// export
export default i18n;


// WEBPACK FOOTER //
// ./src/i18n.js